import * as React from "react";
import Loading from "../../common/fragments/Loading";
import { Query } from "../../core/api/typedQuery";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import Product from "./entities/Product";
import ProductDetailsConfig from "./ProductDetailsConfig";

const ProductQuery = Query.queryOne<Product, any>(Product);

@Panel({id: "productImage", configClass: ProductDetailsConfig, pageParams: true})
class ProductImagePanel extends React.Component<IPanelProps<ProductDetailsConfig>> {

	public render() {
		const { config, pageParams } = this.props;

		if(!pageParams.productId) {
			return "Product not found";
		}

		return (
			<ProductQuery params={{id: pageParams.productId}}>
				{
					({data, loading}) => {

						if(loading) {
							return <Loading />;
						}

						if(!data) {
							return "Product not found";
						}

						return (
							<div style={{width: "100%", height: "300px", background: "url(" + data.iconURL +")", backgroundSize: "cover", position: "relative"}}>
								<div style={{fontSize: "46px", fontWeight: 300, color: "#fff", position: "absolute", left: "20px", bottom: "20px", textShadow: "1px 1px rgba(0, 0, 0, .5)"}}>{data.name}</div>;
							</div>
						);
					}
				}
			</ProductQuery>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/productDetails/ProductImage.panel.tsx